module.exports = __webpack_public_path__ + "img/btn_people_on.11158b57.svg";